import singleItemAPI from './singleItemAPI';

export default {
  single: singleItemAPI,
};
